<template>
  <div>
    <el-tabs>
      <el-tab-pane label="서비스 리스트 보기">
        <ServiceList/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex';
import ServiceList from '@/components/ServiceList';

export default {
  filters: {
    // filterTeamView,
  },
  components: {
    ServiceList,
  },
  computed: {

  },
  methods: {

  },
  data() {
    return {
      name: 'Service',
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Service.vue